import { render, staticRenderFns } from "./TrustDocVerifyNotComplete.vue?vue&type=template&id=b5535442&scoped=true"
import script from "./TrustDocVerifyNotComplete.vue?vue&type=script&lang=js"
export * from "./TrustDocVerifyNotComplete.vue?vue&type=script&lang=js"
import style0 from "./TrustDocVerifyNotComplete.vue?vue&type=style&index=0&id=b5535442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5535442",
  null
  
)

export default component.exports